import React from 'react';
import { PricingCard } from './PricingCard';

export const PricingPlansSection = ({
  plans,
  billingCycle,
  currentPlanName,
  pendingRequest,
  actionBusy,
  onRequest,
  onContactSales,
}) => {
  const getPriceForCycle = (plan, cycle) => {
    switch (cycle) {
      case 'quarterly':
        return plan.quarterlyPrice || Math.round(plan.monthlyPrice * 3 * 0.9); // 10% discount
      case 'annual':
        return plan.annualPrice || Math.round(plan.monthlyPrice * 12 * 0.8); // 20% discount
      default:
        return plan.monthlyPrice || 0;
    }
  };

  const currentPlan = plans.find((p) => p.name === currentPlanName);
  const currentId = currentPlan?.id ?? null;
  const hasPending = Boolean(pendingRequest);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
      {plans.map((plan) => {
        const isCurrent = Boolean(currentPlanName) && plan.name === currentPlanName;
        const requested = hasPending && pendingRequest.requested_plan_id === plan.id;
        const actionLabel = (currentId != null && plan.id != null && plan.id < currentId)
          ? 'Request downgrade'
          : 'Request upgrade';
        return (
          <PricingCard
            key={plan.name}
            name={plan.name}
            idealFor={plan.idealFor}
            price={getPriceForCycle(plan, billingCycle)}
            credits={plan.credits}
            features={plan.features}
            isPopular={plan.isPopular}
            billingCycle={billingCycle}
            isCurrent={isCurrent}
            requested={requested}
            hasPending={hasPending}
            actionLabel={actionLabel}
            actionBusy={actionBusy}
            onRequest={() => onRequest(plan)}
            onContactSales={() => onContactSales(plan)}
          />
        );
      })}
    </div>
  );
};
